import { ActivatedRoute, Router } from '@angular/router';
import { Component, ViewChild, ElementRef, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Material } from './../../models/material.model';
import { MaterialService } from './../../services/material.service';

@Component({
  selector: 'app-detail',
  templateUrl: './detail.component.html',
  styleUrls: ['./detail.component.scss']
})
export class DetailComponent implements OnInit {
  buttonList = {
    backButton: true,
    groupButton: false,
    searchButton: false,
    viewButton: false,
    favButton: false,
    favAllButton: false,
    inFavButton: false,
  }
  public materialDetail$: Observable<Material[]>;
  materialID = [];
  util = '';
  similaridade = [];
  cor = [];
  rapport = [];
  imagePath = [];
  lavado = [];
  ficha = [];
  videoPath = [];
  openOptions: boolean;
  openCor: boolean;
  openRapport: boolean;
  openForma: boolean;
  formaImageActive = 0;

  @ViewChild('videoModal') videoModal: ElementRef;

  constructor(
    private _route: ActivatedRoute,
    private _router: Router,
    private _material: MaterialService,
    private _modal: NgbModal
  ) {
    this.openOptions = false;
    this.openCor = false;
    this.openRapport = false;
    this.openForma = false;
  }

  ngOnInit() {
    this._route.paramMap.subscribe(params => {
      this.materialID = [decodeURI(params.get('id'))];
    });

    this.materialDetail$ = this._material.listMaterial(this.materialID);

    this.materialDetail$.subscribe(material => {
      this.getUtil(material[0].UTILIZACAO);
      this.getSimilaridade(material[0].MATNR.slice(0, 9));
      this.getCor(material[0].SGRUPO, material[0].MATNR.slice(0, 9));
      this.getRapport(material[0].MATNR);
      this.getImagePath(material[0].MATNR.slice(0, 9));
      this.getLavado(material[0].MATNR);
      this.getFicha(material[0].MATNR)
      this.getVideoPath(material[0].MATNR.slice(0, 9));
    });
  }

  showOption(action) {
    switch(action) {
      case 'Cores':
        this.openCor = true;
        this.openRapport = false;
        this.openForma = false;
        break;
      case 'Rapport':
        this.openCor = false;
        this.openRapport = true;
        this.openForma = false;
        break;
      case 'Formas':
        this.openCor = false;
        this.openRapport = false;
        this.openForma = true;
        break;
    }
    this.openOptions = !this.openOptions;
  }

  getUtil(utilizacao) {
    if (utilizacao != ' ' && utilizacao != '') {
      this._material.getMaterialUtil(utilizacao).subscribe(util => this.util = util.toLowerCase());
    } else {
      this.util = '';
    }
  }

  getSimilaridade(materialID) {
    this._material.getMaterialSimilaridade(materialID).subscribe(similaridade => {
      this.similaridade = JSON.parse(similaridade);
    });
  }

  getCor(grupo, materialID) {
    if (grupo == 'Estampado' || grupo == 'Estampados') {
      this.cor = [];
    } else {
      this._material.getMaterialCor(materialID).subscribe(cor => {
        this.cor = cor.sort(function (a, b) {
          if (a.Grupo > b.Grupo) {
            return 1;
          }
          if (a.Grupo < b.Grupo) {
            return -1;
          }
          return 0;
        });
      });
    }
  }

  goToLink(matId, grupo, cod) {
    if(matId.slice(9) != grupo + cod) {
      this._router.navigate(['/catalogo/detail/'], {skipLocationChange: true}).then(() => {
        this._router.navigate(['/catalogo/detail/' + matId.slice(0,9) + grupo + cod]);
      });
    }
    return;
  }

  getRapport(materialID) {
    this._material.getRapport().subscribe(rapportList => {
      this.rapport = rapportList.filter(function(rapport){
        return -1 !== materialID.indexOf(rapport.MATNR);
      });
    });
  }

  getImagePath(materialID) {
    this._material.getMaterialImagePath(materialID).subscribe(imagePath => {
      this.imagePath = JSON.parse(imagePath);
    });
  }

  getLavado(materialID) {
    this.lavado = this._material.getLavagem(materialID);
  }

  getFicha(materialID) {
    this.ficha = this._material.getFichas(materialID);
  }

  getVideoPath(materialID) {
    this._material.getMaterialVideoPath(materialID).subscribe(videoPath => this.videoPath = videoPath);
  }

  openVideo(video) {
    this._modal.open(this.videoModal, { centered: true, windowClass: 'video-modal' });
  }

  print() {
    window.print();
  }

  getStyle(item) {
    let myStyles = {
      'background-color': 'transparent',
      'background-image': 'url(http://189.126.197.169/img/large/large_'+item.MATNR+'.jpg)',
      'background-size': 'cover',
      'background-position': 'center',
      'display': 'block',
      'height': '100%',
      'position': "absolute",
      'top': '0'
    };
    if (item.Master && item.Master.RGB) {
      myStyles = {
        'background-color': 'rgb('+ item.Master.RGB.R +','+ item.Master.RGB.G +' ,'+ item.Master.RGB.B +' )',
        'background-image': 'url(http://189.126.197.169/img/large/large_'+item.MATNR+'.jpg)',
        'background-size': 'cover',
        'background-position': 'center',
        'display': 'block',
        'height': '100%',
        'position': "absolute",
        'top': '0'
      };
    }
    return myStyles;
  }

}
